import { ChangeDetectionStrategy, Component } from '@angular/core';
import { IconComponent } from '@bioreferencehealth/ui-kit';

@Component({
  selector: 'app-forbidden-page.component',
  imports: [IconComponent],
  templateUrl: './forbidden-page.component.html',
  styleUrl: './forbidden-page.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ForbiddenPageComponent {}
